/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Loading_Day_SheetInputs */

const en_orders_loading_day_sheet = /** @type {(inputs: Orders_Loading_Day_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading day sheet...`)
};

const es_orders_loading_day_sheet = /** @type {(inputs: Orders_Loading_Day_SheetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando hoja del dia...`)
};

/**
* | output |
* | --- |
* | "Loading day sheet..." |
*
* @param {Orders_Loading_Day_SheetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_loading_day_sheet = /** @type {((inputs?: Orders_Loading_Day_SheetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Loading_Day_SheetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_loading_day_sheet(inputs)
	return es_orders_loading_day_sheet(inputs)
});